module.exports = __webpack_public_path__ + "static/media/screenshot(52).3d44db1a.jpg";